module.exports = __webpack_public_path__ + "img/gift_bx.a792d509.jpg";